import z from 'zod';
import {firestoreTimestampToDateSchema} from '../_other/firestore/firestoreTimestampToDateSchema';
import {progressDbSchema} from './progressDbSchema';

/**
 * Output schema for progress (id from document id; lastUpdated as Date).
 */
export const progressSchema = progressDbSchema.omit({lastUpdated: true}).extend({
  id: z.string(),
  lastUpdated: firestoreTimestampToDateSchema,
});

export interface Progress extends z.infer<typeof progressSchema> {}
